<template>
  <v-dialog v-model="dialog" persistent max-width="650">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        color="secondary"        
        dark
        v-on="on"
        v-bind="attrs"
        small
        depressed
        :icon="icon"
        title="Trocar usuário"
      >
        <v-icon :left="!icon">mdi-swap-horizontal</v-icon>
        <span v-if="!icon">Trocar usuário</span></v-btn
      >
    </template>
    <v-card :loading="loading">
      <v-card-title class="font-weight-bold">Trocar Usuário</v-card-title>
      <v-card-text>
        <v-radio-group v-model="usuarioSelecionado">
          <v-radio
            v-for="userRelac in usuariosRelacionados"
            :key="userRelac.codigo"
            :value="userRelac.token"
            color="info"
          >
            <template v-slot:label>
              <v-card flat>
                <v-card-title class="subtitle-1">{{
                  userRelac.usuario
                }}</v-card-title>
                <v-card-subtitle class="subtitle-2 pb-0"
                  >{{ userRelac.filial }} -
                  {{ userRelac.descfilial }}/{{userRelac.uf}}</v-card-subtitle
                >
                <v-card-subtitle class="subtitle-2 pt-0">{{
                  userRelac.nome
                }}</v-card-subtitle>
              </v-card>
            </template>
          </v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          color="success"
          @click="confirmarTroca()"
          :loading="trocando"
          text
          >Confirmar troca</v-btn
        >
        <v-btn text rounded @click="dialog = false" color="secondary"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getUsuarios, setarUsuarioLogado } from "@/db/usuario";
import { getToken } from "@/global";

export default {
  props: {
    icon: Boolean,
  },
  watch: {
    dialog: async function (open) {
      if (open) {
        this.loading = true;
        this.usuariosRelacionados = await getUsuarios();
        this.usuarioSelecionado = this.usuariosRelacionados.find(
          (usr) => usr.token == getToken()
        ).token;
        this.loading = false;
      }
    },
  },
  data: () => ({
    loading: true,
    usuariosRelacionados: [],
    usuarioSelecionado: "",
    dialog: false,
    trocando: false,
  }),
  methods: {
    async confirmarTroca() {
      this.trocando = true;
      localStorage.setItem(
        "nutricao-animal-usuario-token",
        this.usuarioSelecionado
      );
      await setarUsuarioLogado(
        this.usuariosRelacionados.find(
          (usr) => usr.token == this.usuarioSelecionado
        )
      );
      this.$router.go();
      this.trocando = false;
    },
  },
};
</script>

<style>
</style>